import React from "react";

import { sql } from "@codemirror/lang-sql";
import CodeMirror from "@uiw/react-codemirror";
import { Copy } from "icons";
import { format } from "sql-formatter";

import { Typography, Modal, Tooltip, Button } from "clearsense-ui/components";
import copyToClipboard from "utils/copyToClipboard";

const QueryModal = ({ viewQuery, theme, setViewQuery }) => (
  <Modal
    data-cy="query-modal"
    size="md"
    isOpen={!!viewQuery.length}
    onClose={() => setViewQuery("")}
    className="query-modal"
  >
    <Modal.Body>
      <div className="flex items-center space-x-4">
        <Typography style="h3" className="my-6">
          View Query
        </Typography>
        <div
          className="text-right text-2xl cursor-pointer hover:text-indigo-500"
          onClick={() => {
            copyToClipboard(
              format(viewQuery, { uppercase: true }),
              "Copied to clipboard"
            );
          }}
        >
          <Tooltip content="Copy SQL Query">
            <Button style="text" icon={Copy} data-cy="copy-query-button" />
          </Tooltip>
        </div>
      </div>
      <CodeMirror
        data-cy="query-editor"
        value={format(viewQuery, { uppercase: true })}
        maxHeight="250px"
        width="100%"
        editable={false}
        extensions={[sql()]}
        className="mb-8 border"
        theme={theme}
      />
    </Modal.Body>
  </Modal>
);

export default QueryModal;
